<div class="bottom-drawer" #bottomDrawer>
  <div class="bottom-drawer-content-wrapper" #bottomDrawerContent>
    <div class="bottom-drawer-content">
      <span class="close-button">
        <ion-button style="transform: scale(0.6);" size="small" *ngIf="showCloseButton" (click)="onCloseClick()">
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </span>
      <ng-content></ng-content>
    </div>
  </div>
</div>
